import { queryOptions } from '@tanstack/react-query'

import { fetchVouchers } from '#admin/features/vouchers/api.ts'

// Under `['ticket']`, so applying a voucher to a registration refreshes the use counts too.
export const vouchersQuery = () =>
  queryOptions({
    queryKey: ['ticket', 'vouchers'],
    queryFn: ({ signal }) => fetchVouchers(signal),
    staleTime: 60_000,
  })
